import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { fetchPublicActivity } from "../../utils/api";
import { Trail } from "../../types/trail";
import { MantrailingDetails } from "./MantrailingDetails";
import { HikingDetails } from "./HikingDetails";
import { DetectionDetails } from "./DetectionDetails";
import { CanicrossDetails } from "./CanicrossDetails";

export function PublicSharedActivity() {
  const { token = "" } = useParams();
  const [params] = useSearchParams();
  const embed = params.get("embed") === "1";
  const [trail, setTrail] = useState<Trail | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchPublicActivity(token)
      .then(({ activityType, activity }) => setTrail({ ...activity, category: activityType } as Trail))
      .catch((e) =>
        setError(e?.response?.status === 410 ? "Ce lien a expiré." : "Ce lien est introuvable ou a été révoqué.")
      );
  }, [token]);

  if (error) return <div className="p-6 text-center text-gray-700">{error}</div>;
  if (!trail) return <div className="p-6 text-center">Chargement...</div>;

  const t: any = trail;
  const title = t.name || (typeof (t.dog ?? t.dogId) === "object" ? (t.dog ?? t.dogId)?.name : "") || "Activité";

  return (
    <div className="min-h-screen bg-white">
      <div className={`mx-auto max-w-5xl space-y-4 ${embed ? "p-2" : "p-4 sm:p-6"}`}>
        {!embed && (
          <header className="flex items-baseline justify-between border-b pb-2">
            <h1 className="text-2xl font-semibold">{title}</h1>
            <span className="text-sm text-gray-500">{new Date(t.date).toLocaleDateString("fr-FR")}</span>
          </header>
        )}
        {t.category === "mantrailing" && <MantrailingDetails trail={t} isPublicShare />}
        {t.category === "hiking" && <HikingDetails trail={t} maxDogMasterDistance={null} />}
        {t.category === "detection" && <DetectionDetails trail={t} isPublicShare />}
        {t.category === "canicross" && <CanicrossDetails trail={t} />}
        {!embed && <footer className="text-center text-xs text-gray-400">Titus Mantrailing</footer>}
      </div>
    </div>
  );
}
